import React from 'react';
import type { Highlight } from '../../types';
import { parseEm } from './parseEm';
import '../../styles/highlight/HighlightLeft.css';

interface HighlightLeftProps {
  data: Highlight;
}

const HighlightLeft: React.FC<HighlightLeftProps> = ({ data }) => (
  <div className="psl-hl-pg psl-hl-pg--left">
    <div className="psl-hl-ribbon">
      <div className="psl-hl-ribbon__lbl">{data.ribbonLabel}</div>
      <div className="psl-hl-ribbon__n">{data.ribbonNumber}</div>
    </div>
    {data.doodle && <div className="psl-hl-doodle">{data.doodle}</div>}

    <div className="psl-hl-chapter">
      <span aria-hidden="true">⸻</span>
      <span>{data.chapterMark}</span>
      <span aria-hidden="true">⸻</span>
    </div>

    <h1 className="psl-hl-title">
      {data.title.pre}
      {data.title.accent && (
        <span className="psl-hl-title__accent">{data.title.accent}</span>
      )}
      {data.title.post}
    </h1>

    <div className="psl-hl-undertitle">{parseEm(data.undertitle)}</div>
    <span className="psl-hl-scribble">{data.scribble}</span>

    <div className="psl-hl-text">
      {data.body.map((block, i) => {
        if (block.kind === 'pull') {
          return (
            <p key={i} className="psl-hl-text__pull">
              {block.text}
            </p>
          );
        }
        if (block.dropcap) {
          const [first, ...rest] = block.text;
          const remainder = rest.join('');
          return (
            <p key={i}>
              <span className="psl-hl-text__dropcap">{first}</span>
              {parseEm(remainder)}
            </p>
          );
        }
        return <p key={i}>{parseEm(block.text)}</p>;
      })}
    </div>

    <div className="psl-hl-signoff">
      <span>{data.signoff}</span>
      <span className="psl-hl-signoff__pgno">{data.pageNumber} · esq.</span>
    </div>
  </div>
);

export default HighlightLeft;
